import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#custom-node-content" }),
  /*#__PURE__*/_createTextVNode(" Custom node content ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " The content of tree nodes can be customized, so you can add icons or buttons as you will ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "custom-tree-container" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "Using render-content", -1)
const _hoisted_8 = { class: "block" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "Using scoped slot", -1)
const _hoisted_10 = { class: "custom-tree-node" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_tree, {
            data: _ctx.data,
            "show-checkbox": "",
            "node-key": "id",
            "default-expand-all": "",
            "expand-on-click-node": false,
            "render-content": _ctx.renderContent
          }, null, 8, ["data", "render-content"])
        ]),
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_el_tree, {
            data: _ctx.data,
            "show-checkbox": "",
            "node-key": "id",
            "default-expand-all": "",
            "expand-on-click-node": false
          }, {
            default: _withCtx(({ node, data }) => [
              _createVNode("span", _hoisted_10, [
                _createVNode("span", null, _toDisplayString(node.label), 1),
                _createVNode("span", null, [
                  _createVNode("a", {
                    onClick: ($event: any) => (_ctx.append(data))
                  }, " Append ", 8, ["onClick"]),
                  _createVNode("a", {
                    onClick: ($event: any) => (_ctx.remove(node, data))
                  }, " Delete ", 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code7), 1)
        ]),
        _: 1
      })
    ])
  ]))
}